/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state:RootState) => state['feature/media-library'] || initialState;

export const selectMediaState = createSelector([selectDomain], (mediaState) => mediaState);
export const selectMedias = createSelector([selectDomain], (mediaState) => mediaState.media);
export const selectMediaTotal = createSelector([selectDomain], (mediaState) => mediaState.total);
export const selectSelectedFiles = createSelector([selectDomain], (mediaState) => mediaState.selectedFiles);
export const selectMediaLoading = createSelector([selectDomain], (mediaState) => mediaState.loading);
export const selectMediaModelLoading = createSelector([selectDomain], (mediaState) => mediaState.modalLoading);
export const selectStroage = createSelector([selectDomain], (mediaState) => mediaState.stroage);

export const selectPage = createSelector([selectDomain], (mediaState) => mediaState.page);
export const selectPerPage = createSelector([selectDomain], (mediaState) => mediaState.perPage);
export const selectPath = createSelector([selectDomain], (mediaState) => mediaState.path);
export const selectCount = createSelector([selectDomain], (mediaState) => mediaState.count);
export const selectType = createSelector([selectDomain], (mediaState) => mediaState.filters.type);
export const selectSortBy = createSelector([selectDomain], (mediaState) => mediaState.filters.sortBy);
export const selectKeyword = createSelector([selectDomain], (mediaState) => mediaState.filters.keyword);
export const selectFiltersApplied = createSelector([selectDomain], (mediaState) => mediaState.filters);
